import { Routes } from '@angular/router';
import { AuthGuard } from 'remarketing-angular-library';

// only by direct URL at /react-hello-world as a reference example for later remote host wiring.
export const reactSpikeRoutes: Routes = [
  {
    path: 'react-hello-world',
    loadComponent: () => import('./react-spike-host.component').then(c => c.ReactSpikeHostComponent),
    canActivate: [AuthGuard],
  },
];
